module.exports = __webpack_public_path__ + "static/80-b6105d24ebb849ecd8b80b55cf3502b8.png";